import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ts",
  "use": "icon-ts-usage",
  "viewBox": "0 0 385.62 833.04",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 385.62 833.04\" id=\"icon-ts\"><defs></defs><g id=\"icon-ts_图层_2\" data-name=\"图层 2\"><g id=\"icon-ts_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M100.15,3.09,347.58,0c27.77-.34,46.11,23.2,33.7,43.26L201.94,333.35h146.6c27.54,0,45.44,23.41,33.11,43.29L98.67,833,201.94,499.91H37c-22.17,0-39.37-15.62-36.78-33.4L64,29.49C66.12,14.61,81.59,3.32,100.15,3.09Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol